/**
 * Secure Storage Adapter for Redux Persist
 * Uses sessionStorage with encryption instead of localStorage
 */
import { secureSessionStorage } from "../utils/secureStorage";

const secureStorageAdapter = {
  getItem: (key) => {
    return new Promise((resolve) => {
      try {
        const value = secureSessionStorage.getItem(key);
        resolve(value ? JSON.stringify(value) : null);
      } catch (error) {
        console.error("SecureStorage getItem error:", error);
        resolve(null);
      }
    });
  },

  setItem: (key, value) => {
    return new Promise((resolve) => {
      try {
        const parsedValue = JSON.parse(value);
        secureSessionStorage.setItem(key, parsedValue);
        resolve();
      } catch (error) {
        console.error("SecureStorage setItem error:", error);
        resolve();
      }
    });
  },

  removeItem: (key) => {
    return new Promise((resolve) => {
      try {
        secureSessionStorage.removeItem(key);
        resolve();
      } catch (error) {
        console.error("SecureStorage removeItem error:", error);
        resolve();
      }
    });
  },
};

export default secureStorageAdapter;
